
let Engine = Matter.Engine,
  Render = Matter.Render,
   Body = Matter.Body,
  Runner = Matter.Runner,
  World = Matter.World,
  Bodies = Matter.Bodies,
  Composite = Matter.Composite,
  Events = Matter.Events,
  Bounds = Matter.Bounds,
  Mouse = Matter.Mouse


let engine = Engine.create();

Matter.use(
  'matter-attractors'
);


let mobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

function init() {

  let canvas = document.querySelector("canvas");
  if(canvas != null){
    canvas.remove();
  }

  let book_info = document.querySelectorAll(".book_info");


  let book_array = Array.from(book_info);

  let larghezza;
  let altezza;
  let restitution;

  if(window.innerWidth < 768){
    larghezza = 280;
    altezza = 43;
    restitution = 0.4;
  }else{
    // larghezza = window.innerWidth/2.2;
    // altezza = window.innerWidth/15;
    larghezza = 455;
    altezza = 70;
    restitution = 0;
  }


  let ground;
  let wall1;
  let wall2;

  const content = document.querySelector('.hero_container');

  let elements = [];

  engine.events = {};
  World.clear(engine.world);
  Engine.clear(engine);

  engine = Engine.create();

  let w = content.offsetWidth;
  let h = content.offsetHeight;

  var render = Matter.Render.create({
    element: content,
    engine: engine,
    options: {
      width: w,
      height: h,
      wireframes: false,
      background: 'transparent',
      wireframeBackground: 'transparent'
    }
  });

  render.mouse = Mouse.create(render.canvas);

  var mouseConstraint = Matter.MouseConstraint.create(engine, {
    mouse: render.mouse,
    constraint: {
      render: {
        visible: false
      }
    }
  });

  mouseConstraint.mouse.element.removeEventListener("mousewheel", mouseConstraint.mouse.mousewheel);
  mouseConstraint.mouse.element.removeEventListener("DOMMouseScroll", mouseConstraint.mouse.mousewheel);



  if(!mobileDevice){

    // uncomment se si vuole aggiungere link a libri al click
    // Events.on(mouseConstraint, 'mouseup', function(event) {
    //   var mouseConstraint = event.source;
    //   var bodies = engine.world.bodies;
    //   if (!mouseConstraint.bodyB) {
    //     for (i = 0; i < bodies.length; i++) {
    //       var body = bodies[i];
    //       if (Matter.Bounds.contains(body.bounds, mouseConstraint.mouse.position)) {
    //         var bodyUrl = body.url;
    //         if (bodyUrl != undefined) {
    //           window.location.href = bodyUrl;
    //         }
    //         break;
    //       }
    //     }
    //   }
    // });

    content.addEventListener('mousemove', () => {
      const query = Matter.Query.point(Composite.allBodies(engine.world), render.mouse.position)
      if (query.length > 0) {
        content.style.cursor = "grab";
      } else {
        content.style.cursor = "auto"
      }
    });
  }

// add books to hero
  for (var i = 0; i < 8; i++) {

    let color = book_array[i].getAttribute('color');
    let url = book_array[i].getAttribute('url');

    var x = Math.random() * w;
    var x2 = Math.floor(Math.random() * (w/2 - w/3 + 1) + w/3)
    var y = Math.random() * -h;
    var rotation = Math.random() * 170;

     let rectangle = Bodies.rectangle(x2, y, larghezza, altezza, {
      frictionAir: 0.0005,
      restitution: restitution,
      render: {
        fillStyle: color,
        lineWidth: 0,
      },
      url: url,
    });
    Matter.Body.rotate(rectangle, rotation)
    elements.push(rectangle);
  }

  // world constraint
  World.add(engine.world, [
    Bodies.rectangle(w / 2, h + 50, w, 100, {
      isStatic: true
    }),
    Bodies.rectangle(-51, h / 2, 100, h, {
      isStatic: true
    }),
    Bodies.rectangle(w + 51, h / 2, 100, h, {
      isStatic: true
    })
  ]);

  if(!mobileDevice){
     setTimeout(function(){
       console.log("hey")
       World.add(engine.world, [
         Bodies.rectangle(w / 2, -50, w, 100, {
           isStatic: true
         }),
       ]);
     }, 3000);
  }


  // mobile change gravity
  let time = 0
  const changeGravity = function() {
   time = time + 0.015
   engine.world.gravity.x = Math.sin(time)
   engine.world.gravity.y = Math.cos(time)
   requestAnimationFrame(changeGravity)
  }

  if(mobileDevice){
    setTimeout(() => {
      World.add(engine.world,
        Bodies.rectangle(h / 2, -50 , h, 100, {
          isStatic: true
        })
      );
      changeGravity()
    }, "3000");

  }


  World.add(engine.world, elements);
  World.add(engine.world, mouseConstraint);


  Runner.run(engine);
  Render.run(render);
}


let logo = document.querySelector(".hero_logo");
logo.classList.add("open");
setTimeout(init, 100);


  let run;
  window.addEventListener('resize', function() {
    clearTimeout(run);
    if(!mobileDevice){
      run = setTimeout(init, 200);
    }
  });

  const setHeroHeight = () => {
    let hero = document.querySelector('.section_hero_wow');
    hero.style.height = window.innerHeight;
  }

 setHeroHeight()
